import Categories from '../navbar/categories';
import Navbar from '../navbar/header';

const Layout = ({ title, page, page2, layoutBgImg, color }) => {

    const backgroundStyle = {
        backgroundImage: `url(${layoutBgImg})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        position: 'absolute',
        top: 0,
        left: 0,
        animation: 'moveBack 7s ease-in-out forwards',
    };
    const isHomePage = page2 === "home";

// const text = color ? color : 'white'

    return (
        <div className={`relative w-full overflow-hidden 
        ${isHomePage ? 'h-[280px] lg:h-[360px] xl:h-[420px] xxl:h-[480px] xxxl:h-[580px]'
                     : 'h-[320px] lg:h-[480px] xxxl:h-[580px]'}`}>
            <div className="absolute top-0 left-0 w-full h-full 
                            bg-center bg-no-repeat z-[-1]"
                style={backgroundStyle}
            ></div>
            <div className="overlayStyle"></div>

            <div className='z-[30] '>
                <Navbar />
            </div> 

            <div className="relative z-[10]">
                <Categories />
            </div>

            <div className='absolute top-0 flex items-center gap-4 w-full 
                             h-full z-[5] justify-center media'>
                <h1 className={`text-center font-bold text-2xl lg:text-3xl 
                               animate-slide-in-bottom px-4 
                               max-w-[70%] xl:max-w-[55%] mt-16  
                               ${color ? `text-${color} ` : 'text-white'}`}>
                    {page ? page : title}
                </h1>
            </div>

        </div>
    )
}

export default Layout